(function ClientTestimonials($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('ClientTestimonials/index', function onload()
		{
			$('.show-all').click(function showMoreReviews() {
				$('.show-all').addClass('hidden');
				$('.show-less').removeClass('hidden');

				$('.testimonial-list').removeClass('hidden');
			});

			$('.show-less').click(function showLessReviews() {
				$('.show-all').removeClass('hidden');
				$('.show-less').addClass('hidden');

				$('.testimonial-list').addClass('hidden');
			});
		});
	});
}(jQuery, window.Adzuki || {}));
